var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { getSpacesWithMaxLengthViolation } from '../utils/spaceBookingPolicyUtils';
/**
 * Returns max-reservation-length policy state for the event composer:
 *   - `violatingSpaceIds`: spaces whose duration cap is exceeded by the
 *     current start/end times. Drives the per-space conflict indicator and
 *     the footer Save-button disable.
 */
export function useMaxReservationLength() {
    var _a = __read(useWatch({ name: ['spaces', 'startTime', 'endTime'] }), 3), spaces = _a[0], startTime = _a[1], endTime = _a[2];
    var violatingSpaceIds = useMemo(function () {
        return getSpacesWithMaxLengthViolation(spaces, startTime, endTime).map(function (s) { return s.id; });
    }, [spaces, startTime, endTime]);
    return {
        violatingSpaceIds: violatingSpaceIds,
        hasMaxLengthViolation: violatingSpaceIds.length > 0,
    };
}
